import { Platform } from 'react-native';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getEnvValue } from './getEnvValue';
import { CustomAxiosError } from './types';

export const instance = axios.create({
  baseURL: getEnvValue('REACT_APP_API_URL'),
  withCredentials: Platform.OS === 'web',
  headers: {
    'Content-Type': 'application/json',
    tenant: getEnvValue('REACT_APP_TENANT_NAME'),
    tenantId: getEnvValue('REACT_APP_TENANT_ID')
  }
});

const onRequest = (config: AxiosRequestConfig) => config;
const onResponse = (response: AxiosResponse): AxiosResponse => response;

export interface ErrorState {
  isError: boolean;
  data: {
    status: number;
    message: string;
  };
}

const onRequestError = (err: CustomAxiosError): Promise<AxiosError> => Promise.reject(err);
const onResponseError = (err: CustomAxiosError): Promise<AxiosError> => Promise.reject(err);

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}

setupInterceptorsTo(instance);
